import { fetchFromAPI } from "./apiService";

const METADATA_KEY = "metadata";
const COUNTRIES_KEY = "countries";
const ENV_KEYS = "envKeys";
/**
 * Gets metadata from localStorage or API.
 * @returns {Promise<Object>} - The metadata object.
 */
export async function getMetadata() {
  // Check localStorage first
  const cached = localStorage.getItem(METADATA_KEY);
  if (cached) {
    return JSON.parse(cached);
  }
  // Fetch from API if not in localStorage
  return await fetchFromAPI("/data/metadata", "GET")
    .then((data) => {
      // Cache the metadata in localStorage
      localStorage.setItem(METADATA_KEY, JSON.stringify(data));
      return data;
    })
    .catch((error) => {
      console.error("Failed to fetch metadata:", error);
      throw error;
    });
}

export async function getCountries() {
  // Check localStorage first
  const cached = localStorage.getItem(COUNTRIES_KEY);

  if (cached) {
    return JSON.parse(cached);
  }
  // Fetch from API if not in localStorage
  return await fetchFromAPI("/data/countries", "GET")
    .then((data) => {
      // Cache the metadata in localStorage
      localStorage.setItem(COUNTRIES_KEY, JSON.stringify(data));
      return data;
    })
    .catch((error) => {
      console.error("Failed to fetch metadata:", error);
      throw error;
    });
}

export async function getEnvKeys() {
  const cached = localStorage.getItem(ENV_KEYS);
  if (cached) {
    return JSON.parse(cached);
  }
  return await fetchFromAPI("/data/env/keys", "GET")
    .then((data) => {
      localStorage.setItem(ENV_KEYS, JSON.stringify(data));
      return data;
    })
    .catch((error) => {
      console.error("Failed to fetch environment keys:", error);
      throw error;
    });
}
